module.exports = __webpack_public_path__ + "static/media/traghetto.d97cff5d.svg";